import Analysis from './Analysis';

export default Analysis;
